import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { Artikel } from '../entities/artikel.entity';
import { KundenFilter } from '../entities/customers/kundenfilter.entity';
import { BeigabenKunde } from '../entities/produkte/beigabenkunde.entity';
import { Beigabe } from '../entities/produkte/beigabe.entity';
//#endregion

@Injectable()
export class BeigabenKundeService extends ODataEntityService<BeigabenKunde> {
  constructor(protected client: ODataClient) {
    super(client, 'BeigabenKunde', 'entities.produkte.BeigabenKunde');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public artikel(entity: EntityKey<BeigabenKunde>): ODataNavigationPropertyResource<Artikel> {
    return this.entity(entity).navigationProperty<Artikel>('artikel');
  }
  public beigabe(entity: EntityKey<BeigabenKunde>): ODataNavigationPropertyResource<Beigabe> {
    return this.entity(entity).navigationProperty<Beigabe>('beigabe');
  }
  public kundenFilter(entity: EntityKey<BeigabenKunde>): ODataNavigationPropertyResource<KundenFilter> {
    return this.entity(entity).navigationProperty<KundenFilter>('kundenFilter');
  }
  //#endregion
}
